import { DEFAULT_LIMIT } from '../SearchManager/FormData';
import {DEFAULT_TOTAL_ITEMS} from "../../../utils/Constants";

export interface IFormData {
  name: string | null
  offset: number
  limit: number
  code: string | null
  total: number
  currentPage: number
}

export class FormData implements IFormData {

  name: string | null
  offset: number
  limit: number
  code: string | null
  total: number
  currentPage: number


  constructor() {
    this.name = null;
    this.offset = 0;
    this.limit = DEFAULT_LIMIT;
    this.code = null;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;

  }

}
